import { get, set } from 'lodash';
import * as _ from 'lodash'
import { FieldArray, FormikProps } from 'formik';
import classNames from 'classnames';
import Flatpickr from 'react-flatpickr'
import {Spanish} from 'flatpickr/dist/l10n/es.js'
import { IMetadataItem, IMetadataSection, IMetadataType, IMetadataTypeCheck, ControlTypes } from '../../report-metadata/ReportMetadata.model';
import { CustomInputRenderer } from '../../../common/component/CustomInputRenderer';

interface Props {
  keys: string[]
  collection?: any[]
  idVisible?: boolean
  collapsed?: boolean
  disabled?: boolean
  path?: string
  depth?: number
}

const AssetMetadataViewer = ({
  keys,
  collection,
  path,
  depth = 0,
  idVisible = true,
  collapsed = false,
  disabled = false,
}: Props) => {

  const renderNumberInput = (item) => {
    const valueAtPath = item.value
    const metricValueAtPath = item.metricValue
    return (
      <CustomInputRenderer
        label={item.label?.toUpperCase() ?? ''}
        value={`${valueAtPath ?? ''} ${
          !metricValueAtPath || metricValueAtPath === 'N/A' ? '' : metricValueAtPath
        }`}
      ></CustomInputRenderer>
    )
  }

  const renderTextInput = (item) => {
    const valueAtPath = item.value
    const metricValueAtPath = item.metricValue
    return (
      <CustomInputRenderer
        label={item.label?.toUpperCase() ?? ''}
        value={`${valueAtPath ?? ''} ${
          !metricValueAtPath || metricValueAtPath === 'N/A' ? '' : metricValueAtPath
        }`}
      ></CustomInputRenderer>
    )
  }

  const renderTextArea = (item) => {
    const valueAtPath = item.value
    return (
      <CustomInputRenderer
        label={item.label?.toUpperCase() ?? ''}
        value={`${valueAtPath ?? ''}`}
      ></CustomInputRenderer>
    )
  }

  const renderSingleSelection = (item) => {
    const valueAtPath = item.selectValue
    return (
      <CustomInputRenderer
        label={item.label?.toUpperCase() ?? ''}
        value={`${valueAtPath ?? ''}`}
      ></CustomInputRenderer>
    )
  }

  const renderDatePicker = (item) => {
    const valueAtPath = item.value
    return (
      <CustomInputRenderer
        label={item.label?.toUpperCase() ?? ''}
        value={`${valueAtPath ?? ''}`}
      ></CustomInputRenderer>
    )
  }

  const renderNestedItems = (item: IMetadataSection, path: string, depth: number) => {
    return (
      <>
        <div className='flex'>
          {item.items.map((item, index) =>
            renderRecursively(index, item, `${path}.items.${index}`, ++depth)
          )}
        </div>
      </>
    )
  }

  const renderRecursively = (key, item, path, depth) => {
    const renderType = (item, path) => {
      if (item.type === ControlTypes.INPUT_NUMBER) {
        return renderNumberInput(item)
      } else if (item.type === ControlTypes.INPUT_TEXT) {
        return renderTextInput(item)
      } else if (item.type === ControlTypes.TEXTAREA) {
        return renderTextArea(item)
      } else if (item.type === ControlTypes.SINGLE_CHOICE) {
        return renderSingleSelection(item)
      } else if (item.type === ControlTypes.DATE) {
        return renderDatePicker(item)
      } else if (item.items) {
        return renderNestedItems(item, path, depth)
      }
    }

    return (
      <div
        key={key}
        className={classNames({
          'col-12': depth === 0,
          'col-12 my-2': depth !== 0,
        })}
      >
        <div className='row'>{renderType(item, path)}</div>
      </div>
    )
  }

  return (
    <div>
      {collection && (
        <div className='flex'>
          {collection.map((item, index) =>
            renderRecursively(index, item, `${path}.${index}`, depth)
          )}
        </div>
      )}
    </div>
  )
}

export {AssetMetadataViewer}
